// Shared customer terms for documents and Snelscan. PG rules target a group;
// an explicitly assigned customer group always wins over a legacy PG fallback.
const clean = value => String(value ?? '').trim().toLowerCase();
const amount = value => Number.parseFloat(String(value ?? '').replace(',', '.'));
const rules = customer => Array.isArray(customer?.kortingen) ? customer.kortingen : [];

export const customerPriceGroup = (customer, fallback = 'basic') => {
  const assigned = clean(customer?.kortinggroep);
  if (assigned) return assigned;
  const legacy = rules(customer).find(rule => clean(rule.artikel).startsWith('pg:'));
  return clean(legacy?.artikel).slice(3).trim() || fallback;
};

const ruleTier = (rule, article, group, variant) => {
  const target = clean(rule.artikel), category = clean(article?.categorie);
  if (!target) return 4;
  if (target.startsWith('pg:')) return clean(target.slice(3)) === clean(group) ? 3 : -1;
  if (target.startsWith('cat:')) return clean(target.slice(4)) === category ? 2 : -1;
  if (variant && [variant.art_code, variant.code].some(code => code && clean(code) === target)) return 0;
  if ([article?.art_code, article?.master_art_code].some(code => code && target === clean(code))) return 1;
  return category && target === category ? 2 : -1;
};

export const customerDiscount = (article, customer, group, variant = null) => {
  const tiers = [0, 0, 0, 0, 0];
  for (const rule of rules(customer)) {
    const tier = ruleTier(rule, article, group, variant), pct = amount(rule.percentage);
    if (tier >= 0 && Number.isFinite(pct) && pct > 0) tiers[tier] = Math.max(tiers[tier], Math.min(100, pct));
  }
  return tiers.find(value => value > 0) || 0;
};

export const customerFixedPrice = (article, customer, group, variant = null) => {
  const tiers = [null, null, null, null, null];
  for (const rule of rules(customer)) {
    const tier = ruleTier(rule, article, group, variant), price = amount(rule.vast_bedrag);
    if (tier >= 0 && Number.isFinite(price) && price > 0) tiers[tier] = price;
  }
  return tiers.find(value => value != null) ?? null;
};